<template lang="pug">
Navigation(:items='menuState')
</template>

<script lang="ts" setup>
const { menuState, fetchMenu } = useMenu();

await fetchMenu();
</script>
